export default "__VITE_ASSET__Cksm23yS__"